import React from 'react';

import clsx from 'clsx';

/**
 * A header/divider block that can be slotted into GlassCardGrid like a card.
 *
 * @param root0
 * @param root0.title
 * @param root0.subtitle
 * @param root0.span
 * @param root0.className
 */
const GlassCardHeader = ({ title, subtitle, span = 12, className }) => (
  <div className={clsx('glass-card-header', `glass-card-header--span-${span}`, className)} role="presentation">
    <div className="glass-card-header__title">{title}</div>
    {subtitle !== null && <div className="glass-card-header__subtitle">{subtitle}</div>}
  </div>
);

export default GlassCardHeader;
